import type { ComponentProps } from 'react'
import { CONTENT_ATTRIBUTE } from '~/lib/content/links'
import { richTextClass } from './classes'

type Props = Omit<
  ComponentProps<'div'>,
  'dangerouslySetInnerHTML' | 'children'
> & {
  html: string
  /** `article`: blog/news body and /animalcare (18/28). `campaign`: campaign body (dark 15.6/28). */
  variant?: 'article' | 'campaign'
}

/** Renders Markdown-derived HTML with Webflow-faithful typography. */
export function RichText({
  html,
  variant = 'article',
  className = '',
  ...props
}: Props) {
  return (
    <div
      className={`${richTextClass(variant)} ${className}`}
      {...CONTENT_ATTRIBUTE}
      dangerouslySetInnerHTML={{ __html: html }}
      {...props}
    />
  )
}
